export default "__VITE_ASSET__CnbNJ3zF__"